import { environment } from "../../../../../../environments/environment";
import { PublicationTemplateType } from "../../data/entities/publication-templates.entity";

export class GetAvailablePublicationTypesInteractor {
  public execute(): PublicationTemplateType[] {
    return environment.features.betaCampaignType
      .publicationTypes as PublicationTemplateType[];
  }
}
